// @flow

const OrganizationMemberSSOModeConstants = {
  REQUIRED: "REQUIRED",
  OPTIONAL: "OPTIONAL",
};

export type OrganizationMemberSSOModes = $Values<
  typeof OrganizationMemberSSOModeConstants,
>;

export default OrganizationMemberSSOModeConstants;
